import {Injectable, signal} from '@angular/core';

/**
 * Drives the "leave without saving" dialog. The guard awaits the promise,
 * the dialog mounted in the app shell resolves it.
 */
@Injectable({providedIn: 'root'})
export class UnsavedChangesService {

  readonly isVisible = signal(false);

  private resolveLeave: ((leave: boolean) => void) | null = null;

  confirmLeave(): Promise<boolean> {
    this.isVisible.set(true);
    return new Promise<boolean>(resolve => this.resolveLeave = resolve);
  }

  answer(leave: boolean) {
    this.isVisible.set(false);
    this.resolveLeave?.(leave);
    this.resolveLeave = null;
  }
}
